import { CREATE_FORUMS, CREATE_USER } from './actionTypes';
import { UserStateType, forumType } from './reducer';

export type UserTypeAction = { type: string; data: any };

export const createUser = (user: UserStateType): UserTypeAction => ({
  type: CREATE_USER,
  data: {
    authentifie: user.authentifie,
    id: user.id,
    url: user.url,
    agence: user.agence,
    nom: user.nom,
    prenom: user.prenom,
    profils: user.profils,
    manager: user.manager,
    partenaire: user.partenaire,
    email: user.email,
    token: user.token,
    nextAuthDate: user.nextAuthDate,
  },
});

export const createForums = (data: forumType[]): UserTypeAction => ({
  type: CREATE_FORUMS,
  data,
});
